import { styled } from '@mui/material/styles';
import { Backdrop } from '@mui/material';

export const StyledBackdrop = styled(Backdrop, {
  shouldForwardProp: (prop) => prop !== 'disableBlur',
})(({ theme, disableBlur }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backdropFilter: disableBlur ? null : 'blur(2px)',
}));
